import React from 'react';
import Modal from 'shared/modals/Modal';
import InventoryUnitMultipleAddForm from '../../forms/InventoryUnitMultipleAddForm/InventoryUnitMultipleAddForm';

const InventoryUnitMultipleAddModal = ({
  onClose,
  orderId
}) => {

  console.log(orderId);
  return (
    <Modal isOpen={true} title={`Add Multiple`} handleClose={onClose} containerStyle='medium' width={500}>
      <section className={`cost-form`}>
          <InventoryUnitMultipleAddForm onClose={onClose} orderId={orderId} />
      </section>
    </Modal>
  );
};

export default InventoryUnitMultipleAddModal;